import BottomSheet from '@components/BottomSheet'
import CacheClient from '@plug-core/clients/CacheClient'
import { logger } from '@plug-core/logger'
import { useLocales } from '@plug-core/state'
import { ListGroup, ListRow, RowTile } from '@ui'
import React, { useEffect, useState } from 'react'
import { HiCheckCircle } from 'react-icons/hi2'

const LocaleSettings = () => {
  const { locales, setUserLocale, setLocales, userLocale } = useLocales()

  const [currencySelectVisible, setCurrencySelectVisible] = useState(false)

  useEffect(() => {
    ;(async () => {
      const client = new CacheClient()

      try {
        const locales = await client.getLocales()
        setLocales(locales)
      } catch (e) {
        logger.error('Failed to fetch locale info', { originalError: e })
      }
    })()
  }, [])

  return (
    <div className="mb-3 flex flex-col gap-4">
      <ListGroup>
        <ListRow
          primary="Currency"
          secondary={`${userLocale.currency.code.toUpperCase()} ${userLocale.currency.symbol}`}
          chevron
          onClick={() => setCurrencySelectVisible(true)}
        />
      </ListGroup>

      <BottomSheet
        visible={currencySelectVisible}
        onBackdropClick={() => setCurrencySelectVisible(false)}
        title="Currency"
      >
        <ListGroup>
          {locales.map((locale) => {
            const selected = locale.id === userLocale.id
            return (
              <ListRow
                key={locale.currency.code}
                aria-current={selected || undefined}
                selected={selected}
                leading={<RowTile>{locale.flagEmoji}</RowTile>}
                primary={locale.currency.name}
                secondary={locale.currency.symbol}
                trailing={
                  selected && <HiCheckCircle aria-hidden="true" className="size-5 text-success" />
                }
                onClick={() => {
                  setUserLocale(locale)
                  setCurrencySelectVisible(false)
                }}
              />
            )
          })}
        </ListGroup>
      </BottomSheet>
    </div>
  )
}

export default LocaleSettings
